module.exports = __vendor;


//////////////////
// WEBPACK FOOTER
// external "__vendor"
// module id = 12
// module chunks = 0 1